export default "__VITE_ASSET__DxUXXUM1__"